import { useEffect } from "react";
import { useNotification } from "../contexts/NotificationContext";

export default function TawkTo() {
  const TAWK_URL = process.env.REACT_APP_TAWK_URL;
  const { showNotification } = useNotification();

  useEffect(() => {
    if (!TAWK_URL) {
      showNotification("Chat bot having some issue, try later");
      return;
    }

    // Restrict widget to allowed hosts
    const allowedHosts = [
      
      "ecstacommerce.com",
      "www.ecstacommerce.com",
    ];

    if (!allowedHosts.includes(window.location.hostname)) return;

    // Prevent multiple script injections
    if (document.querySelector(`script[data-tawk="true"]`)) return;

    const s1 = document.createElement("script");
    const s0 = document.getElementsByTagName("script")[0];

    s1.async = true;
    s1.src = TAWK_URL;
    s1.charset = "UTF-8";
    s1.setAttribute("data-tawk", "true");

    s0.parentNode.insertBefore(s1, s0);

    // Read store details safely
    let storeDetails = {};
    try {
      storeDetails = JSON.parse(
        sessionStorage.getItem("wixStoreDetails") || "{}"
      );
    } catch (e) {
      console.error("Failed to parse wixStoreDetails", e);
    }

    // Initialize Tawk API
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    window.Tawk_API.onLoad = function () {
      if (!storeDetails?.wixUserId) return;

      window.Tawk_API.setAttributes(
        {
          name: storeDetails.storeName || "Wix Merchant",
          email: storeDetails.email || "",
          wixUserId: storeDetails.wixUserId,
          plan: storeDetails?.plan?.name || "Free",
          country: storeDetails.country || "",
          currentPage: window.location.pathname,
        },
        function (error) {
          if (error) {
            console.error("Tawk attribute error:", error);
          }
        }
      );
    };
  }, [TAWK_URL, showNotification]);

  return null;
}
